// @ vendor
const moment = require('moment');
// @ utilities
const isNull = require('lodash/lang/isNull');
const { getControlDigitFromCodBban } = require('utilities/ibanHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const { download } = require('utilities/fileDownloadHelper');
const { formatText } = require('core/i18n').i18n;
import { openPDFViewer, showPDFFailure } from 'utilities/contactCenter/pdfViewer';
// @ constants
const { DATE_FORMAT_API } = require('constants/index');
const actionTypes = require('constants/actionTypes');
const { TYPES } = require('constants/movementsTypes');
import { VIEWER } from 'constants/contactCenter/pdfViewer';
const EXCEL_DOCUMENT = 't';
const PDF_DOCUMENT = 'p';
const FILE_FORMAT_PDF = 'PDF';
const TRANSACTION_TYPE = ' ';
const CONCEPT = '000';

const requestAccountTransactionsDownloadInProgress = () => ({
    type: actionTypes.FETCH_ACCOUNT_TRANSACTIONS_DOWNLOAD_REQUEST
});

const requestAccountTransactionsDownloadSuccess = () => ({
    type: actionTypes.FETCH_ACCOUNT_TRANSACTIONS_DOWNLOAD_SUCCESS
});

const requestAccountTransactionsDownloadFailure = (payload) => ({
    type: actionTypes.FETCH_ACCOUNT_TRANSACTIONS_DOWNLOAD_FAILURE,
    payload
});

const requestAccountTransactionsDownloadScaRequired = (accountId, fileFormat) => ({
    type: actionTypes.FETCH_ACCOUNT_TRANSACTIONS_DOWNLOAD_SCA_REQUIRED,
    accountId,
    fileFormat
});

const resetAccountTransactionsDownloadSca = () => ({
    type: actionTypes.FETCH_ACCOUNT_TRANSACTIONS_DOWNLOAD_SCA_RESET
});

const resetScaForAccountTransactionsDownload = () => (dispatch) => {
    dispatch(resetAccountTransactionsDownloadSca());
}


const downloadAccountsTransactions = (accountId, fileFormat, loadType = undefined) => (dispatch, getState) => {
    const immAccount =
        getState().accounts.getIn(['byId', accountId]) ||
        getState().accounts.getIn(['futureAccountsById', accountId]);
    const immFilter = getState().accountsTransactions.get('filters');
    let amountFrom;
    let amountTo;
    let dateFrom;
    let dateTo;
    let amountFromCurrency;
    let amountToCurrency;
    let movementType;
    let concept;

    const documentType = fileFormat === FILE_FORMAT_PDF ? PDF_DOCUMENT : EXCEL_DOCUMENT;

    const requestData = {
        header: {
            responseType: !__CONTACT_CENTER__ ? 'arraybuffer' : 'blob'
        },
        query: {
            digitoControl: getControlDigitFromCodBban(immAccount.getIn(['ibanComplex', 'codbban'])),
            producto: immAccount.get('product'),
            contrato: immAccount.get('contractNumber'),
            numeroCuenta: immAccount.get('product') + immAccount.get('contractNumber'),
            tipoMovimiento: TRANSACTION_TYPE,
            tipoArchivo: documentType,
            concepto: CONCEPT,
            titular: immAccount.get('accountHolder')
        }
    };

    movementType = immFilter.getIn(['movementType', 'movementType']);
    if (!isNull(movementType) && movementType !== TYPES.ALL) {
        requestData.query.tipoMovimiento = movementType;
    }

    concept = immFilter.getIn(['concept', 'concept']);
    if (!isNull(concept) && concept !== TYPES.ALL) {
        requestData.query.concepto = concept;
    }

    amountFrom = immFilter.get('amount').get('from').get('amount');
    if (!isNull(amountFrom)) {
        requestData.query.importeDesde = amountFrom;

        amountFromCurrency = immFilter.get('amount').get('from').get('currency');
        requestData.query.divisaImporteDesde = amountFromCurrency;
    }

    amountTo = immFilter.get('amount').get('to').get('amount');
    if (!isNull(amountTo)) {
        requestData.query.importeHasta = amountTo;

        amountToCurrency = immFilter.get('amount').get('to').get('currency');
        requestData.query.divisaImporteHasta = amountToCurrency;
    }

    dateFrom = immFilter.get('date').get('from');
    dateTo = immFilter.get('date').get('to');
    if (dateFrom && dateTo) {
        requestData.query.fechaDesde = moment(dateFrom).format(DATE_FORMAT_API);
        requestData.query.fechaHasta = moment(dateTo).format(DATE_FORMAT_API);
    } else {
        // If no dates are selected for the filter, we get movements from last 2 years
        requestData.query.fechaDesde = moment()
            .startOf('day')
            .subtract(2, 'year')
            .format(DATE_FORMAT_API);
        requestData.query.fechaHasta = moment().startOf('day').format(DATE_FORMAT_API);
    }

    dispatch(requestAccountTransactionsDownloadInProgress(accountId));

    return APIGet(dispatch, apiURLBuilder.getURL('accountDownloadTransactions'), requestData).then(
        response => {
            const result = response.xhr.response;
            let fileName;
            let fileType;
            if (documentType === EXCEL_DOCUMENT) {
                fileName = `${formatText('applicationDownloadFileNames-accountsTransactions')}.xls`;
                fileType = 'application/vnd.ms-excel';
            } else {
                fileName = `${formatText('applicationDownloadFileNames-accountsTransactions')}.pdf`;
                fileType = 'application/pdf';
            }
            dispatch(requestAccountTransactionsDownloadSuccess(response, accountId));
            if (!loadType) {
                download(result, fileName, fileType);
            } else if (loadType === VIEWER) {
                openPDFViewer(result);
            }
        },
        error => {
            if (loadType === VIEWER) {
                showPDFFailure();
            }
            if (error.error && error.error.status && error.error.status === 403) {
                dispatch(requestAccountTransactionsDownloadScaRequired(accountId, fileFormat))
            } else {
                dispatch(requestAccountTransactionsDownloadFailure(error, accountId));
            }

        }
    );
};

module.exports = {
    downloadAccountsTransactions,
    resetScaForAccountTransactionsDownload
};
